async function cancelWithdrawal(baseConfig, requestConfig) {
    const url = `${baseConfig.apiUrl}/api/user/transaction/${baseConfig.merchantId}/${requestConfig.userProfileId}/${requestConfig.transactionId}?sessionId=${requestConfig.sessionId}`;
    const requestOptions = {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
    };
    const request = await fetch(url, requestOptions);
    await request.json();
    // TODO: Check status?
    return true;
}

export { cancelWithdrawal };
